import { call, put } from 'redux-saga/effects'
import { toast } from 'react-hot-toast'

import api from 'Src/api'
import history from '../../history'
import {
  fetchAllKBSuccess,
  fetchKBSectionsSuccess,
  deleteKBSuccess,
  updateKBSuccess,
  syncKBSuccess,
  addKBFailure,
  addKBSuccess
} from 'Actions/kb'

const ADD_KB_URL = 'v1/kb'
const FETCH_KB_SECTIONS_URL = 'v1/kb/:kb_id/sections'
const DELETE_KB_URL = 'v1/kb/:kb_id'
const UPDATE_KB_URL = 'v1/kb/:kb_id'
const SYNC_KB_URL = 'v1/kb/:kb_id/sync'

export const addKB = function* ({ payload }) {
  const { name, kb_type, url, file } = payload

  const toastId = toast.loading(`Verifying and adding ${name}...`)

  try {
    if (kb_type !== 'csv_file') {
      yield call(api.post, ADD_KB_URL, {
        name,
        kb_type,
        url
      })
    } else if (kb_type === 'csv_file') {
      const data = new FormData()
      data.append('name', name)
      data.append('kb_type', kb_type)
      data.append('file', file)
      yield call(api.post, ADD_KB_URL, data, { headers: { 'Content-Type': 'multipart/form-data' } })
    }
    yield put(addKBSuccess())
    toast.success(`Started syncing ${name}`, { id: toastId })
    history.push('/knowledge-base')
  } catch (error) {
    yield put(addKBFailure())
    toast.error(`Unable to add ${name}. Please try again`, { id: toastId })
    console.error('Unable to add KB', error)
  }
}

export const fetchAllKB = function* ({ payload }) {
  try {
    const response = yield call(api.get, ADD_KB_URL, {})
    yield put(fetchAllKBSuccess({ kbList: response.data }))
    if (response.data.length === 0) {
      history.push('/knowledge-base-import')
    }
  } catch (error) {
    console.error('Unable to fetch all KB', error)
  }
}

export const fetchKBSections = function* ({ payload }) {
  const { kbId } = payload
  try {
    const response = yield call(api.get, FETCH_KB_SECTIONS_URL, {
      urlParams: {
        kb_id: kbId
      }
    })
    yield put(fetchKBSectionsSuccess({ kbSections: response.data }))
  } catch (error) {
    console.error('Unable to fetch KB', error)
  }
}

export const deleteKB = function* ({ payload }) {
  const { kbId } = payload
  try {
    const response = yield call(api.delete, DELETE_KB_URL, {
      urlParams: {
        kb_id: kbId
      }
    })
    toast.success('Marked for deletion. Will be deleted in a few minutes.')
    yield put(deleteKBSuccess({ kb: response.data }))
  } catch (error) {
    toast.error('Unable to delete KB')
    console.error('Unable to delete KB', error)
  }
}

export const updateKB = function* ({ payload }) {
  const { kbId, name, ignore_sections } = payload
  try {
    const response = yield call(
      api.patch,
      UPDATE_KB_URL,
      {
        name,
        ignore_sections
      },
      {
        urlParams: {
          kb_id: kbId
        }
      }
    )
    yield put(updateKBSuccess({ kb: response.data }))
    toast.success(`Updated ${name} successfully`)
  } catch (error) {
    toast.error(`Unable to update ${name}. Please try again.`)
    console.error('Unable to update KB', error)
  }
}

export const syncKB = function* ({ payload }) {
  const { kbId } = payload
  try {
    yield call(
      api.put,
      SYNC_KB_URL,
      {},
      {
        urlParams: {
          kb_id: kbId
        }
      }
    )
    toast.success('Started syncing knowledge base')
    yield put(syncKBSuccess({ kbId }))
  } catch (error) {
    toast.error('Unable to sync KB')
    console.error('Unable to update KB', error)
  }
}
